import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import GoalsPageFilter from './GoalsPageFilter';
import { getGoalEntriesStatuses } from '../../../../selectors';
import {
    getLocales,
    getAccess
} from './GoalsPageFilter.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    locales: getLocales,
    access: getAccess,
    statuses: getGoalEntriesStatuses
});

const GoalsPageFilterComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {};
    }
)(withRouter(GoalsPageFilter));

export default GoalsPageFilterComponent;
